<template>
  <div>
   </div>
</template>

<script>

export default {
  name: 'BondedSelling',
  props: {
    product: {type:Object, required:true},
    taxes: {type:Array, required:true}
  }
}
</script>